export default __webpack_public_path__ + "static/media/telegramadd.7c323c36.svg";